import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import styles from './Process.module.scss';
import { Block, BlockContent, Card, Icon, Typography } from 'components/elements';
import { WPAcfProcess } from 'types/acf/process';
import DOMPurify from 'dompurify';
import { Polygon as PolygonIcon } from 'assets/icons';
import { useCurrentWidth } from 'hooks/dom';
import { isMobile } from 'utils';

interface OwnProps {
  data: WPAcfProcess | null;
}

type ProcessProps = JSX.IntrinsicElements['div'] & OwnProps;

const Process: FunctionComponent<ProcessProps> = props => {
  const { data: processData } = props;
  const [tileHeight, setTileHeight] = useState(0);
  const containerRef = useRef();
  const windowWidth = useCurrentWidth();

  const selectBiggest = () => {
    let height = 0;
    // @ts-ignore
    document.querySelectorAll(`[data-parent="process"] [data-type="process-tile"]`).forEach((item: Element) => {
      if (item.clientHeight > height) {
        height = item.clientHeight;
      }
    });
    return height;
  };

  const wrapperRef = useCallback(node => {
    if (node && !isMobile()) {
      containerRef.current = node;
      setTileHeight(selectBiggest());
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (containerRef?.current && !isMobile()) {
      setTileHeight(selectBiggest());
    }
    // eslint-disable-next-line
  }, [windowWidth, processData]);

  if (!processData) {
    return null;
  }

  const { header, items } = processData;

  return (
    <Block id="process" theme="white" data-module="process">
      <BlockContent>
        <div className={styles.wrapper}>
          {header && (
            <Typography mobile="new_neue_semibold_26" tablet="new_neue_semibold_26" desktop="new_neue_32_h1" as="div" className={styles.header}>
              <h3>{DOMPurify.sanitize(header)}</h3>
            </Typography>
          )}
          <div className={styles.items} ref={wrapperRef}>
            {items?.map(({ header, description }, index) => (
              <div data-parent={`process`} key={`process-item`} className={styles.item}>
                <div>
                  <Card {...(tileHeight && { maxHeight: tileHeight })}>
                    <div data-type="process-tile" className={styles.content}>
                      {header && (
                        <Typography mobile="neue_semibold_20" tablet="neue_semibold_20" desktop="new_neue_20_h2" as="div" className={styles.title}>
                          <Icon size={35} icon={PolygonIcon} />
                          <h4>{DOMPurify.sanitize(header)}</h4>
                        </Typography>
                      )}
                      {description && (
                        <Typography
                          mobile="new_ibm_regular_16"
                          as="p"
                          className={styles.description}
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
                        />
                      )}
                    </div>
                  </Card>
                </div>
              </div>
            ))}
          </div>
        </div>
      </BlockContent>
    </Block>
  );
};

export default Process;
